// Copyright (c) Docugami, Inc. All rights reserved.
import { DisplayActionTypes, SET_NAVIGATION_BAR_VISIBILITY, SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY, SET_UPGRADE_MODAL_DISPLAY_PROPS, UpgradeModalDisplayProps } from "./types";

export function setNavigationBarVisibility(visible: boolean): DisplayActionTypes {
    return {
        type: SET_NAVIGATION_BAR_VISIBILITY,
        payload: visible
    };
}

export function setUpgradeModalDisplayProps(props: UpgradeModalDisplayProps): DisplayActionTypes {
    return {
        type: SET_UPGRADE_MODAL_DISPLAY_PROPS,
        payload: props
    };
}

export function hideUpgradeModal(): DisplayActionTypes {
    return {
        type: SET_UPGRADE_ACCOUNT_MODAL_VISIBILITY,
        payload: false
    };
}